// extracted by mini-css-extract-plugin
export var attachment = "_ro-a";
export var emailContainer = "_ro-4";
export var emailContentPaddedContainer = "_ro-b";
export var emailHeader = "_ro-6";
export var emailIframe = "_ro-3";
export var emailInfoIcon = "_ro-9";
export var emailShortenedSummary = "_ro-e";
export var infoDropdown = "_ro-0";
export var infoRowBoundedContent = "_ro-d";
export var internal = "_ro-5";
export var merchant = "_ro-8";
export var messageInputContainer = "_ro-h";
export var normal = "_ro-7";
export var replyCard = "_ro-f";
export var subtleButton = "_ro-1";
export var subtleButtonIconContainer = "_ro-2";
export var toggleViewRepliesButton = "_ro-c";
export var wrappingText = "_ro-g";